import { render } from "./LookupRelationTable.vue?vue&type=template&id=61d272f0"
import script from "./LookupRelationTable.vue?vue&type=script&lang=js"
export * from "./LookupRelationTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__